import { render, staticRenderFns } from "./mark-works.vue?vue&type=template&id=3380f756&"
import script from "./mark-works.vue?vue&type=script&lang=js&"
export * from "./mark-works.vue?vue&type=script&lang=js&"
import style0 from "./mark-works.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports